import { Union, Record } from "../../fable_modules/fable-library.3.7.20/Types.js";
import { union_type, list_type, anonRecord_type, float64_type, bool_type, int32_type, class_type, record_type, option_type, string_type } from "../../fable_modules/fable-library.3.7.20/Reflection.js";
import { UTC$reflection } from "../../fable_modules/Svea.Dry.Fable.1.0.4/Time.fs.js";
import { fromString, list, int, bool, int64, datetimeLocal, decimal, datetimeOffset, string, object } from "../../fable_modules/Thoth.Json.10.2.0/Decode.fs.js";
import { TransactionTypeDescModule_fromString, PaymentStatusModule_fromString, ClaimStatusModule_fromString, TransactionTypeDesc$reflection, PaymentStatus$reflection, ClaimStatus$reflection } from "../../DomainTypes.js";
import { bind, map } from "../../fable_modules/fable-library.3.7.20/Option.js";
import { DateModule_parse, DateFormat_get_yyyy$002DMM$002Ddd } from "../../Svea.Dry/Time.js";
import { uncurry } from "../../fable_modules/fable-library.3.7.20/Util.js";
import { abs, compare, equals, op_Subtraction, fromParts, op_Addition } from "../../fable_modules/fable-library.3.7.20/Decimal.js";

export class InvoiceEmailDTO extends Record {
    constructor(Subject, Message, RecipientEmail, SenderEmail) {
        super();
        this.Subject = Subject;
        this.Message = Message;
        this.RecipientEmail = RecipientEmail;
        this.SenderEmail = SenderEmail;
    }
}

export function InvoiceEmailDTO$reflection() {
    return record_type("Containers.Invoices.Model.InvoiceEmailDTO", [], InvoiceEmailDTO, () => [["Subject", string_type], ["Message", string_type], ["RecipientEmail", string_type], ["SenderEmail", option_type(string_type)]]);
}

export class PaymentOptions extends Record {
    constructor(BankgiroNr, PlusgiroNr, IBAN, BIC) {
        super();
        this.BankgiroNr = BankgiroNr;
        this.PlusgiroNr = PlusgiroNr;
        this.IBAN = IBAN;
        this.BIC = BIC;
    }
}

export function PaymentOptions$reflection() {
    return record_type("Containers.Invoices.Model.PaymentOptions", [], PaymentOptions, () => [["BankgiroNr", option_type(string_type)], ["PlusgiroNr", option_type(string_type)], ["IBAN", option_type(string_type)], ["BIC", option_type(string_type)]]);
}

export class InvoiceDueDateDTO extends Record {
    constructor(DueDate) {
        super();
        this.DueDate = DueDate;
    }
}

export function InvoiceDueDateDTO$reflection() {
    return record_type("Containers.Invoices.Model.InvoiceDueDateDTO", [], InvoiceDueDateDTO, () => [["DueDate", string_type]]);
}

export class SendSMSDTO extends Record {
    constructor(ToNumber, Message) {
        super();
        this.ToNumber = ToNumber;
        this.Message = Message;
    }
}

export function SendSMSDTO$reflection() {
    return record_type("Containers.Invoices.Model.SendSMSDTO", [], SendSMSDTO, () => [["ToNumber", string_type], ["Message", string_type]]);
}

export class ReminderFeeDTO extends Record {
    constructor(InvoiceeNr, ReminderInvoiceNr, Reason) {
        super();
        this.InvoiceeNr = InvoiceeNr;
        this.ReminderInvoiceNr = ReminderInvoiceNr;
        this.Reason = Reason;
    }
}

export function ReminderFeeDTO$reflection() {
    return record_type("Containers.Invoices.Model.ReminderFeeDTO", [], ReminderFeeDTO, () => [["InvoiceeNr", class_type("System.Int64")], ["ReminderInvoiceNr", class_type("System.Int64")], ["Reason", string_type]]);
}

export class InvoiceFee extends Record {
    constructor(FeeNr, Description, AmountExclVat, AmountInclVat, Period, PeriodFrom, PeriodTo, ContractNr, IsChecked) {
        super();
        this.FeeNr = (FeeNr | 0);
        this.Description = Description;
        this.AmountExclVat = AmountExclVat;
        this.AmountInclVat = AmountInclVat;
        this.Period = Period;
        this.PeriodFrom = PeriodFrom;
        this.PeriodTo = PeriodTo;
        this.ContractNr = ContractNr;
        this.IsChecked = IsChecked;
    }
}

export function InvoiceFee$reflection() {
    return record_type("Containers.Invoices.Model.InvoiceFee", [], InvoiceFee, () => [["FeeNr", int32_type], ["Description", string_type], ["AmountExclVat", class_type("System.Decimal")], ["AmountInclVat", class_type("System.Decimal")], ["Period", string_type], ["PeriodFrom", class_type("System.DateOnly")], ["PeriodTo", option_type(class_type("System.DateOnly"))], ["ContractNr", option_type(int32_type)], ["IsChecked", bool_type]]);
}

export class CampaignCode extends Record {
    constructor(CampaignCode, Description) {
        super();
        this.CampaignCode = CampaignCode;
        this.Description = Description;
    }
}

export function CampaignCode$reflection() {
    return record_type("Containers.Invoices.Model.CampaignCode", [], CampaignCode, () => [["CampaignCode", string_type], ["Description", string_type]]);
}

export class ReminderFee extends Record {
    constructor(InvoiceeNr, ReminderInvoiceNr, Fee, VatRatePercent, Reason, DeletedAt, ReminderIncludedInvoiceNr, ReminderIncludedInvoiceDate) {
        super();
        this.InvoiceeNr = InvoiceeNr;
        this.ReminderInvoiceNr = ReminderInvoiceNr;
        this.Fee = Fee;
        this.VatRatePercent = VatRatePercent;
        this.Reason = Reason;
        this.DeletedAt = DeletedAt;
        this.ReminderIncludedInvoiceNr = ReminderIncludedInvoiceNr;
        this.ReminderIncludedInvoiceDate = ReminderIncludedInvoiceDate;
    }
}

export function ReminderFee$reflection() {
    return record_type("Containers.Invoices.Model.ReminderFee", [], ReminderFee, () => [["InvoiceeNr", class_type("System.Int64")], ["ReminderInvoiceNr", class_type("System.Int64")], ["Fee", class_type("System.Decimal")], ["VatRatePercent", class_type("System.Decimal")], ["Reason", option_type(string_type)], ["DeletedAt", option_type(class_type("System.DateOnly"))], ["ReminderIncludedInvoiceNr", option_type(class_type("System.Int64"))], ["ReminderIncludedInvoiceDate", option_type(class_type("System.DateOnly"))]]);
}

export class PaymentApiDTO extends Record {
    constructor(BookedDate, Category, ClientNr, CustomerNr, Date$, InvoiceCurrency, InvoiceNr, PaymentAmount, PaymentAmountCurrency, PaymentTypeCode, TransactionTypeCode) {
        super();
        this.BookedDate = BookedDate;
        this.Category = Category;
        this.ClientNr = ClientNr;
        this.CustomerNr = CustomerNr;
        this.Date = Date$;
        this.InvoiceCurrency = InvoiceCurrency;
        this.InvoiceNr = InvoiceNr;
        this.PaymentAmount = PaymentAmount;
        this.PaymentAmountCurrency = PaymentAmountCurrency;
        this.PaymentTypeCode = PaymentTypeCode;
        this.TransactionTypeCode = TransactionTypeCode;
    }
}

export function PaymentApiDTO$reflection() {
    return record_type("Containers.Invoices.Model.PaymentApiDTO", [], PaymentApiDTO, () => [["BookedDate", option_type(class_type("System.DateTime"))], ["Category", option_type(int32_type)], ["ClientNr", option_type(int32_type)], ["CustomerNr", option_type(class_type("System.Int64"))], ["Date", option_type(class_type("System.DateTime"))], ["InvoiceCurrency", option_type(string_type)], ["InvoiceNr", option_type(class_type("System.Int64"))], ["PaymentAmount", option_type(float64_type)], ["PaymentAmountCurrency", option_type(float64_type)], ["PaymentTypeCode", option_type(string_type)], ["TransactionTypeCode", option_type(int32_type)]]);
}

export class InvoiceNoteDTO extends Record {
    constructor(ClientNumber, InvoiceNoteNumber, InvoiceNumber, Note, Updated, UserName) {
        super();
        this.ClientNumber = (ClientNumber | 0);
        this.InvoiceNoteNumber = (InvoiceNoteNumber | 0);
        this.InvoiceNumber = InvoiceNumber;
        this.Note = Note;
        this.Updated = Updated;
        this.UserName = UserName;
    }
}

export function InvoiceNoteDTO$reflection() {
    return record_type("Containers.Invoices.Model.InvoiceNoteDTO", [], InvoiceNoteDTO, () => [["ClientNumber", int32_type], ["InvoiceNoteNumber", int32_type], ["InvoiceNumber", class_type("System.Int64")], ["Note", option_type(string_type)], ["Updated", option_type(UTC$reflection())], ["UserName", option_type(string_type)]]);
}

export class CreateNewPaymentApiDTO extends Record {
    constructor(note, paymentamount, transactiontypecode) {
        super();
        this.note = note;
        this.paymentamount = paymentamount;
        this.transactiontypecode = (transactiontypecode | 0);
    }
}

export function CreateNewPaymentApiDTO$reflection() {
    return record_type("Containers.Invoices.Model.CreateNewPaymentApiDTO", [], CreateNewPaymentApiDTO, () => [["note", option_type(string_type)], ["paymentamount", option_type(class_type("System.Decimal"))], ["transactiontypecode", int32_type]]);
}

export class S5PaymentError extends Record {
    constructor(Errors) {
        super();
        this.Errors = Errors;
    }
}

export function S5PaymentError$reflection() {
    return record_type("Containers.Invoices.Model.S5PaymentError", [], S5PaymentError, () => [["Errors", list_type(anonRecord_type(["Description", option_type(string_type)]))]]);
}

export class CreateNewPaymentResponseApiDTO extends Record {
    constructor(ClientNr, CustomerNr, Date$, InvoiceNr, PaymentAmount, PaymentNr, TransactionTypeCode) {
        super();
        this.ClientNr = ClientNr;
        this.CustomerNr = CustomerNr;
        this.Date = Date$;
        this.InvoiceNr = InvoiceNr;
        this.PaymentAmount = PaymentAmount;
        this.PaymentNr = PaymentNr;
        this.TransactionTypeCode = TransactionTypeCode;
    }
}

export function CreateNewPaymentResponseApiDTO$reflection() {
    return record_type("Containers.Invoices.Model.CreateNewPaymentResponseApiDTO", [], CreateNewPaymentResponseApiDTO, () => [["ClientNr", option_type(int32_type)], ["CustomerNr", option_type(class_type("System.Int64"))], ["Date", option_type(string_type)], ["InvoiceNr", option_type(class_type("System.Int64"))], ["PaymentAmount", option_type(float64_type)], ["PaymentNr", option_type(class_type("System.Int64"))], ["TransactionTypeCode", option_type(int32_type)]]);
}

export class SoftReminder extends Record {
    constructor(ReminderVia, SentAt) {
        super();
        this.ReminderVia = ReminderVia;
        this.SentAt = SentAt;
    }
}

export function SoftReminder$reflection() {
    return record_type("Containers.Invoices.Model.SoftReminder", [], SoftReminder, () => [["ReminderVia", string_type], ["SentAt", class_type("System.DateTimeOffset")]]);
}

export function SoftReminder_get_Decoder() {
    return (path_2) => ((v) => object((get$) => {
        let objectArg, objectArg_1;
        return new SoftReminder((objectArg = get$.Required, objectArg.Field("reminder_via", string)), (objectArg_1 = get$.Required, objectArg_1.Field("sent_at", datetimeOffset)));
    }, path_2, v));
}

export class Invoice extends Record {
    constructor(AmountExclVat, ClaimStatus, ClaimStoppedFrom, ClaimStoppedTo, DueDate, InvoiceDate, InvoiceNumber, IsCardPayment, OcrNumber, PayedAmount, PaymentDate, PaymentStatus, Reminder_1, ReminderSent, RequirementClass, SoftReminders, TransactionType, TransactionTypeDesc, Vat) {
        super();
        this.AmountExclVat = AmountExclVat;
        this.ClaimStatus = ClaimStatus;
        this.ClaimStoppedFrom = ClaimStoppedFrom;
        this.ClaimStoppedTo = ClaimStoppedTo;
        this.DueDate = DueDate;
        this.InvoiceDate = InvoiceDate;
        this.InvoiceNumber = InvoiceNumber;
        this.IsCardPayment = IsCardPayment;
        this.OcrNumber = OcrNumber;
        this.PayedAmount = PayedAmount;
        this.PaymentDate = PaymentDate;
        this.PaymentStatus = PaymentStatus;
        this.Reminder_1 = Reminder_1;
        this.ReminderSent = ReminderSent;
        this.RequirementClass = RequirementClass;
        this.SoftReminders = SoftReminders;
        this.TransactionType = TransactionType;
        this.TransactionTypeDesc = TransactionTypeDesc;
        this.Vat = Vat;
    }
}

export function Invoice$reflection() {
    return record_type("Containers.Invoices.Model.Invoice", [], Invoice, () => [["AmountExclVat", option_type(class_type("System.Decimal"))], ["ClaimStatus", option_type(ClaimStatus$reflection())], ["ClaimStoppedFrom", option_type(class_type("System.DateOnly"))], ["ClaimStoppedTo", option_type(class_type("System.DateOnly"))], ["DueDate", option_type(class_type("System.DateTime"))], ["InvoiceDate", class_type("System.DateTime")], ["InvoiceNumber", class_type("System.Int64")], ["IsCardPayment", bool_type], ["OcrNumber", option_type(string_type)], ["PayedAmount", option_type(class_type("System.Decimal"))], ["PaymentDate", option_type(class_type("System.DateTime"))], ["PaymentStatus", option_type(PaymentStatus$reflection())], ["Reminder_1", option_type(class_type("System.Decimal"))], ["ReminderSent", option_type(class_type("System.DateOnly"))], ["RequirementClass", option_type(int32_type)], ["SoftReminders", list_type(SoftReminder$reflection())], ["TransactionType", option_type(int32_type)], ["TransactionTypeDesc", option_type(TransactionTypeDesc$reflection())], ["Vat", option_type(class_type("System.Decimal"))]]);
}

export function Invoice_get_Decoder() {
    return (path_16) => ((v) => object((get$) => {
        let objectArg, objectArg_1, option_1, objectArg_2, format, option_2, objectArg_3, format_1, objectArg_4, objectArg_5, objectArg_6, objectArg_7, objectArg_8, objectArg_9, objectArg_10, objectArg_11, objectArg_12, option_4, objectArg_13, format_2, objectArg_14, arg_31, decoder, objectArg_15, objectArg_16, objectArg_17, objectArg_18;
        return new Invoice((objectArg = get$.Optional, objectArg.Field("amount_excl_vat", decimal)), map(ClaimStatusModule_fromString, (objectArg_1 = get$.Optional, objectArg_1.Field("claim_status", string))), (option_1 = ((objectArg_2 = get$.Optional, objectArg_2.Field("claim_stopped_from", string))), bind((format = DateFormat_get_yyyy$002DMM$002Ddd(), (s) => DateModule_parse(format, s)), option_1)), (option_2 = ((objectArg_3 = get$.Optional, objectArg_3.Field("claim_stopped_to", string))), bind((format_1 = DateFormat_get_yyyy$002DMM$002Ddd(), (s_1) => DateModule_parse(format_1, s_1)), option_2)), (objectArg_4 = get$.Optional, objectArg_4.Field("due_date", datetimeLocal)), (objectArg_5 = get$.Required, objectArg_5.Field("invoice_date", datetimeLocal)), (objectArg_6 = get$.Required, objectArg_6.Field("invoice_number", uncurry(2, int64))), (objectArg_7 = get$.Required, objectArg_7.Field("is_card_payment", bool)), (objectArg_8 = get$.Optional, objectArg_8.Field("ocr_number", string)), (objectArg_9 = get$.Optional, objectArg_9.Field("payed_amount", decimal)), (objectArg_10 = get$.Optional, objectArg_10.Field("payment_date", datetimeLocal)), map(PaymentStatusModule_fromString, (objectArg_11 = get$.Optional, objectArg_11.Field("payment_status", string))), (objectArg_12 = get$.Optional, objectArg_12.Field("reminder_1", decimal)), (option_4 = ((objectArg_13 = get$.Optional, objectArg_13.Field("reminder_sent", string))), bind((format_2 = DateFormat_get_yyyy$002DMM$002Ddd(), (s_2) => DateModule_parse(format_2, s_2)), option_4)), (objectArg_14 = get$.Optional, objectArg_14.Field("requirement_class", uncurry(2, int))), (arg_31 = ((decoder = SoftReminder_get_Decoder(), (path_13) => ((value_13) => list(uncurry(2, decoder), path_13, value_13)))), (objectArg_15 = get$.Required, objectArg_15.Field("soft_reminders", uncurry(2, arg_31)))), (objectArg_16 = get$.Optional, objectArg_16.Field("transaction_type", uncurry(2, int))), map(TransactionTypeDescModule_fromString, (objectArg_17 = get$.Optional, objectArg_17.Field("transaction_type_desc", string))), (objectArg_18 = get$.Optional, objectArg_18.Field("vat", decimal)));
    }, path_16, v));
}

export function Invoice_get_ListDecoder() {
    const decoder = Invoice_get_Decoder();
    return (path) => ((value) => list(uncurry(2, decoder), path, value));
}

export function Invoice_get_DecodeFromString() {
    const decoder = Invoice_get_ListDecoder();
    return (value) => fromString(uncurry(2, decoder), value);
}

export class UpcomingInvoiceFee extends Record {
    constructor(AmountExclVat, AmountInclVat, ContractNumber, Description, Period, PeriodFrom, PeriodTo) {
        super();
        this.AmountExclVat = AmountExclVat;
        this.AmountInclVat = AmountInclVat;
        this.ContractNumber = ContractNumber;
        this.Description = Description;
        this.Period = Period;
        this.PeriodFrom = PeriodFrom;
        this.PeriodTo = PeriodTo;
    }
}

export function UpcomingInvoiceFee$reflection() {
    return record_type("Containers.Invoices.Model.UpcomingInvoiceFee", [], UpcomingInvoiceFee, () => [["AmountExclVat", class_type("System.Decimal")], ["AmountInclVat", class_type("System.Decimal")], ["ContractNumber", option_type(int32_type)], ["Description", string_type], ["Period", string_type], ["PeriodFrom", class_type("System.DateOnly")], ["PeriodTo", option_type(class_type("System.DateOnly"))]]);
}

export function UpcomingInvoiceFee_get_Decoder() {
    return (path_6) => ((v) => object((get$) => {
        let objectArg, objectArg_1, objectArg_2, objectArg_3, objectArg_4, _arg, s, objectArg_5, option, objectArg_6, format_1;
        return new UpcomingInvoiceFee((objectArg = get$.Required, objectArg.Field("amount_excl_vat", decimal)), (objectArg_1 = get$.Required, objectArg_1.Field("amount_incl_vat", decimal)), (objectArg_2 = get$.Optional, objectArg_2.Field("contract_number", uncurry(2, int))), (objectArg_3 = get$.Required, objectArg_3.Field("description", string)), (objectArg_4 = get$.Required, objectArg_4.Field("period", string)), (_arg = ((s = ((objectArg_5 = get$.Required, objectArg_5.Field("period_from", string))), DateModule_parse(DateFormat_get_yyyy$002DMM$002Ddd(), s))), (_arg == null) ? (() => {
            throw (new Error("[UpcomingInvoiceFee.PeriodFrom] Error: Cannot parse date"));
        })() : _arg), (option = ((objectArg_6 = get$.Optional, objectArg_6.Field("period_to", string))), bind((format_1 = DateFormat_get_yyyy$002DMM$002Ddd(), (s_1) => DateModule_parse(format_1, s_1)), option)));
    }, path_6, v));
}

export function UpcomingInvoiceFee_get_ListDecoder() {
    const decoder = UpcomingInvoiceFee_get_Decoder();
    return (path) => ((value) => list(uncurry(2, decoder), path, value));
}

export class UpcomingInvoice extends Record {
    constructor(AmountExclVat, AmountInclVat, Fees, NextInvoiceDate) {
        super();
        this.AmountExclVat = AmountExclVat;
        this.AmountInclVat = AmountInclVat;
        this.Fees = Fees;
        this.NextInvoiceDate = NextInvoiceDate;
    }
}

export function UpcomingInvoice$reflection() {
    return record_type("Containers.Invoices.Model.UpcomingInvoice", [], UpcomingInvoice, () => [["AmountExclVat", class_type("System.Decimal")], ["AmountInclVat", class_type("System.Decimal")], ["Fees", list_type(UpcomingInvoiceFee$reflection())], ["NextInvoiceDate", class_type("System.DateOnly")]]);
}

export function UpcomingInvoice_get_Decoder() {
    return (path_3) => ((v) => object((get$) => {
        let objectArg, objectArg_1, arg_5, objectArg_2, _arg, s, objectArg_3;
        return new UpcomingInvoice((objectArg = get$.Required, objectArg.Field("amount_excl_vat", decimal)), (objectArg_1 = get$.Required, objectArg_1.Field("amount_incl_vat", decimal)), (arg_5 = UpcomingInvoiceFee_get_ListDecoder(), (objectArg_2 = get$.Required, objectArg_2.Field("fees", uncurry(2, arg_5)))), (_arg = ((s = ((objectArg_3 = get$.Required, objectArg_3.Field("next_invoice_date", string))), DateModule_parse(DateFormat_get_yyyy$002DMM$002Ddd(), s))), (_arg == null) ? (() => {
            throw (new Error("[UpcomingInvoiceFee.PeriodFrom] Error: Cannot parse date"));
        })() : _arg));
    }, path_3, v));
}

export function UpcomingInvoice_get_ListDecoder() {
    const decoder = UpcomingInvoice_get_Decoder();
    return (path) => ((value) => list(uncurry(2, decoder), path, value));
}

export function getAmount(invoice) {
    const matchValue = [invoice.AmountExclVat, invoice.Vat];
    if (matchValue[0] != null) {
        if (matchValue[1] != null) {
            const amount_1 = matchValue[0];
            const vat = matchValue[1];
            return op_Addition(amount_1, vat);
        }
        else {
            const amount = matchValue[0];
            return amount;
        }
    }
    else {
        return fromParts(0, 0, 0, false, 1);
    }
}

export class PayState extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["Paid", "PartiallyPaid", "Unpaid", "Unknown"];
    }
}

export function PayState$reflection() {
    return union_type("Containers.Invoices.Model.PayState", [], PayState, () => [[], [["RemainingAmount", class_type("System.Decimal")]], [["RemainingAmount", class_type("System.Decimal")]], []]);
}

export function PayState_GetPayState_2E0C21E3(invoice) {
    const getPayState = (amount, payedAmount) => {
        const remainingAmount = op_Subtraction(amount, payedAmount);
        if (equals(remainingAmount, amount)) {
            return new PayState(2, remainingAmount);
        }
        else if (equals(remainingAmount, fromParts(0, 0, 0, false, 1)) ? true : (compare(payedAmount, amount) >= 0)) {
            return new PayState(0);
        }
        else {
            return new PayState(1, abs(remainingAmount));
        }
    };
    const matchValue = [invoice.AmountExclVat, invoice.Vat, invoice.PayedAmount];
    if (matchValue[0] != null) {
        if (matchValue[2] != null) {
            if (matchValue[1] != null) {
                const amount_2 = matchValue[0];
                const payedAmount_2 = matchValue[2];
                const vat = matchValue[1];
                return getPayState(op_Addition(amount_2, vat), payedAmount_2);
            }
            else {
                const amount_1 = matchValue[0];
                const payedAmount_1 = matchValue[2];
                return getPayState(amount_1, payedAmount_1);
            }
        }
        else {
            const amountExclVat = matchValue[0];
            return new PayState(2, amountExclVat);
        }
    }
    else {
        return new PayState(3);
    }
}

